<div class="accordion">
  <div
    class="accordion-header"
    (click)="toggleExpanded()"
    (keydown.enter)="toggleExpanded()"
    (keydown.space)="toggleExpanded()"
    tabindex="0"
    >
    <div class="header-wrapper">
      @if (headerTemplate) {
        <ng-container *ngTemplateOutlet="headerTemplate"></ng-container>
      } @else {
        <div class="default-header">
          <hyperkit-typography
            class="header-title"
            variant="emphasized"
            size="sm"
            align="left"
            color="primary"
            >{{ title }}</hyperkit-typography
            >
            <div class="header-actions">
              @if (badgeText && badgeText.length > 0) {
                <hyperkit-tag
                  class="header-badge"
                  [mode]="'outline'"
                  [closable]="false"
                  [text]="badgeText"
                  >
                </hyperkit-tag>
              }
            </div>
          </div>
        }

        <div class="icon-container">
          <hyperkit-icon
            class="arrow-icon"
            [ngClass]="{ expanded: expanded }"
            icon="chevron-down"
            size="base"
          ></hyperkit-icon>
        </div>
      </div>
    </div>

    <div
      class="accordion-content"
      [@expandCollapse]="expanded ? 'expanded' : 'collapsed'"
      >
      <ng-content></ng-content>
    </div>
  </div>
